import $ from 'jquery';
import _ from 'underscore';
import { onImgLoad } from '../lib/utils.js';

import ResponsiveMap from './ResponsiveMap';
import DetailedFloorPlan from './DetailedFloorPlan';

export default class Floorplan {
  constructor (floorplan) {
    if (!floorplan.querySelector('.c-floorplan__img[usemap]')) return false;

    var self = this;

    this.floorplan = floorplan
    this.img = floorplan.querySelector('.c-floorplan__img');
    this.imgmap = floorplan.querySelector('.c-floorplan__map');
    this.svg = floorplan.querySelector('.c-floorplan__svg');
    this.units = floorplan.querySelector('.c-floorplan__units');
    this.contents = floorplan.querySelector('.c-floorplan__contents');

    this.detailed = new DetailedFloorPlan({
      el: floorplan.querySelector('.js-explorer-detailed'),
      contents: floorplan.querySelector('.c-floorplan__contents')
    });

    this.polygons = [];

    onImgLoad(this.img, function () {
      self.init();
      self.listen();
    })
  }

  init() {
    this.responsiveMap = new ResponsiveMap(this.img, this.imgmap);
    this.getPolygons();
    // this.initSvg();
    this.createPolygons();
  }

  listen() {
    var self = this;

    this.units?.addEventListener('mouseover', e => {
      var clickEl = $(e.target).closest('.c-apartment-unit')[0];
      var clickID = (clickEl) ? clickEl.getAttribute('data-target-id') : null;

      this.clearAllClass('hover');
      this.unitsAddHover(clickID);
      this.svgAddHover(clickID);
    });

    this.imgmap.addEventListener('mouseover', e => {
      var clickID = e.target.getAttribute('data-target-id');

      this.clearAllClass('hover');
      this.unitsAddHover(clickID);
      this.svgAddHover(clickID);
    });

    this.imgmap.addEventListener('mouseout', e => {
      this.clearAllClass('hover');
    });

    this.unitsClicked = function(e) {
      this.disableUnitsBtn(this.units, this.unitsClickHandler);
      var clickEl = $(e.target).closest('.c-apartment-unit')[0];
      var clickID = (clickEl) ? clickEl.getAttribute('data-target-id') : null;

      if (clickID) {
        var areaEl = this.imgmap.querySelector(`[data-target-id=${clickID}]`);
        this.detailed.show(areaEl);
        this.clearAllClass('click');
        this.unitsAddHover(clickID, true);
        this.svgAddHover(clickID, true);
      }
    }
    this.unitsClickHandler = this.unitsClicked.bind(this);
    this.units?.addEventListener('click', this.unitsClickHandler);

    this.imgmapClicked = function (e) {
      this.disableUnitsBtn(this.imgmap, this.imgmapClickHandler);
      this.detailed.show(e.target);

      var clickID = e.target.getAttribute('data-target-id')
      this.clearAllClass('click');
      this.unitsAddHover(clickID, true);
      this.svgAddHover(clickID, true);
    }
    this.imgmapClickHandler = this.imgmapClicked.bind(this);
    this.imgmap.addEventListener('click', this.imgmapClickHandler);
  }

  disableUnitsBtn(element, handler) {
    element.removeEventListener('click', handler);
    setTimeout(() => {
      element.addEventListener('click', handler);
    }, 550);
  }

  unitsAddHover(id, toggle) {
    if (!toggle) toggle = false;

    var unit = this.units.querySelector(`[data-target-id=${id}]`);
    if (unit) {
      (toggle) ? $(unit).toggleClass('click') : $(unit).addClass('hover');
    }
  }

  clearAllClass(className) {
    for(var i = 0; i < this.svg.childNodes.length; i++) {
      $(this.svg.childNodes[i]).removeClass(className);
    }

    var units = this.units?.querySelectorAll('.c-apartment-unit');
    for(var i = 0; i < units.length; i++) {
      $(units[i]).removeClass(className);
    }
  }

  svgAddHover(id, toggle) {
    if (!toggle) toggle = false;

    var svgShape = this.svg.querySelector(`#${id}`);
    if (svgShape) {
      (toggle) ? $(svgShape).toggleClass('click') : $(svgShape).addClass('hover');
    }
  }

  // initSvg() {
  //   console.dir(this.img.naturalWidth);
  //   console.dir(this.img.naturalHeight);
  //   this.svg.setAttribute('viewBox', `0 0 ${this.img.naturalWidth} ${this.img.naturalHeight}`);
  // }

  createPolygons() {
    for(var i = 0; i < this.polygons.length; i++) {
      var formattedPoints = this.getPolygonPoints(this.polygons[i].coords);
      var polygon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
      polygon.setAttribute('points', formattedPoints);
      polygon.setAttribute('id', this.polygons[i].id);
      polygon.setAttribute('class', this.polygons[i].className);
      this.svg.insertBefore(polygon, null);
    }
  }

  getPolygonPoints(coords) {
    var coordsArray = coords.toString().split(',');
    var formattedCoordArray = [];

    for(var i=0; i<coordsArray.length; i+=2) {
      var formattedCoord = coordsArray[i] + ',' + coordsArray[i+1];
      formattedCoordArray.push(formattedCoord);
    }
    return formattedCoordArray.join(' ');
  }

  getPolygons() {
    var self = this;
    _.each(this.responsiveMap.getMapOri().areas, function(val) {
      self.polygons.push({
        coords: val.coords,
        id: val.getAttribute('data-target-id'),
        className: val.className,
      });
    });
  }
}
